import { createRoutineCreator } from 'redux-saga-routines';
//////////////////////////////////////////////////

const createCRUDRoutine = createRoutineCreator([
  'FETCH', 'FETCH_SUCCESS', 'FETCH_FAILURE',
  'FETCH_NEXT', 'FETCH_NEXT_SUCCESS', 'FETCH_NEXT_FAILURE',
  'RESET_PAGINATION',
  'ADD', 'ADD_SUCCESS', 'ADD_FAILURE',
  'GET', 'GET_SUCCESS', 'GET_FAILURE',
  'UPDATE', 'UPDATE_SUCCESS', 'UPDATE_FAILURE',
  'DELETE', 'DELETE_SUCCESS', 'DELETE_FAILURE',
]);

const createFileRoutine = createRoutineCreator([
  'UPLOAD', 'UPLOAD_SUCCESS', 'UPLOAD_FAILURE',
  'GET', 'GET_SUCCESS', 'GET_FAILURE',
  'DELETE', 'DELETE_SUCCESS', 'DELETE_FAILURE',
  'DOWNLOAD', 'DOWNLOAD_SUCCESS', 'DOWNLOAD_FAILURE',
  'EXAMPLE', 'EXAMPLE_SUCCESS', 'EXAMPLE_FAILURE',
]);

export {
  createCRUDRoutine,
  createFileRoutine,
};
